export class VideoError {
    id: string;
    constructor(data: string) {
        this.id = data;
    }
}
